module.exports = __webpack_public_path__ + "static/media/save.3c5348d5.svg";